<script setup lang="ts">
import SwitchLanguage from './SwitchLanguage.vue'
import SwitchOddType from './SwitchOddType.vue'
import { useAuthStore } from '@/stores/auth'
import { domainLogos } from '@/domainsLogos'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

// Get user data and domain logo
const authStore = useAuthStore()
const { getUser } = storeToRefs(authStore)
const currentDomain = window.location.hostname
const defaultLogo = domainLogos[currentDomain]

// Determine which logo to show
const logoSrc = computed(() => getUser.value?.logo || defaultLogo)
</script>

<template>
  <footer
    class="pt-4 px-3 pb-[90px] max-w-xl mx-auto h-auto border-t border-white/10"
  >
    <div class="text-center">

      <!-- Logo -->
      <div class="h-12 flex justify-center mb-3">
        <RouterLink to="/">
          <div
            v-if="!getUser?.logo"
            class="hm-Logo h-12"
            :style="{ backgroundImage: `url(${logoSrc})` }"
          />
          <img
            v-else
            :src="logoSrc"
            alt="Logo"
            class="hm-Logo h-12 object-contain mx-auto"
          />
        </RouterLink>
      </div>

      <!-- Controls -->
      <div class="mb-4 space-y-2 sm:space-y-0 sm:flex sm:justify-center sm:gap-3">
        <SwitchLanguage class="w-full sm:w-auto" />
        <SwitchOddType class="w-full sm:w-auto" />
      </div>

      <!-- Links -->
      <div
        class="flex flex-col sm:flex-row justify-center items-center gap-3 text-[12px] text-gray-400 mb-3"
      >
        <router-link
          to="/terms"
          class="hover:text-green-500 transition underline underline-offset-4"
        >
          {{ $t('terms.1') }}
        </router-link>
        <span class="hidden sm:block text-gray-500">•</span>
        <a
          href="https://www.responsiblegambling.org/"
          target="_blank"
          class="hover:text-green-500 transition"
        >
          Responsible Gambling
        </a>
      </div>

      <!-- Legal Text -->
      <div class="text-neutral-500 space-y-1 text-[11px]">
        <p>{{ $t('footer.page') }}</p>
        <p>{{ $t('footer.games') }}</p>
        <p>{{ $t('footer.rights') }}</p>
      </div>

      <!-- Age / Licensing -->
      <div class="flex items-center justify-center mt-5">
        <a href="https://www.responsiblegambling.org/" target="_blank">
          <img
            src="/plus21.svg"
            alt="21+"
            class="w-[32px] h-[32px] cursor-pointer hover:opacity-80 transition"
          />
        </a>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.hm-Logo {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
